import React from 'react';

export const ClockIcon: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%'>
        <g id='clock'>
            <path
                id='^ Name above ^'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 3C7.029 3 3 7.029 3 12C3 16.971 7.029 21 12 21C16.971 21 21 16.971 21 12C21 7.029 16.971 3 12 3ZM15 15.5C14.863 15.498 14.739 15.441 14.65 15.35L11.5 12.21V6C11.5 5.724 11.724 5.5 12 5.5C12.276 5.5 12.5 5.724 12.5 6V11.79L15.35 14.64C15.438 14.73 15.493 14.854 15.493 14.99C15.493 15.264 15.273 15.486 15 15.49V15.5Z'
            />
        </g>
    </svg>
);